import { FC, useState } from "react";
import { useForm } from "react-hook-form";

import { serverCreateNewUser } from "api/api-server-actions";
import { AccountForm, AccountFormValue } from "components/sso/AccountForm";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { toastErrorMessage, toastSuccessMessage } from "utils/alerts";

interface AddUserModalProps {
  open: boolean;
  onClose: () => void;
}

export const AddUserModal: FC<AddUserModalProps> = ({ open, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const form = useForm<AccountFormValue>();

  const handleSubmit = async (data: AccountFormValue) => {
    setIsLoading(true);
    try {
      await serverCreateNewUser({
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name || "",
        password: data.password || "",
        confirm_password: data.confirm_password || "",
        send_onboarding_email: data.send_onboarding_email || false,
      });

      toastSuccessMessage(t("admin.add_user.success_message"));

      onClose();
    } catch (err) {
      toastErrorMessage(err instanceof Error ? err.message : t("error.toasts.unknown"));
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    form.reset();
    onClose();
  };

  return (
    <Dialog open={open} title={t("admin.add_user.add_user")} onClose={handleClose}>
      <div className="modal-body font-normal">
        <AccountForm
          isLoading={isLoading}
          forAdding
          onCancel={handleClose}
          onSubmit={handleSubmit}
        />
      </div>
    </Dialog>
  );
};
